<script>
import List from './List.vue'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: List, // End of Component > extends

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    mounted() {
       
    },
    watch: {
        model(value) {
            console
            if (value) {
                let selectedItem = this.options.find(
                    (item) => item._id === value
                )
                console.log("selected", selectedItem)

                if (this.field.key == 'accountInfo.bankId') {
                    if(selectedItem.dataSegmentId == process.env.VUE_APP_SSA_ACCOUNT){

                        this.$store.commit('updateField', {
                            key: 'asaanAccInfo.bank',
                            value: selectedItem.value,
                        })
                    } else {
                        this.$store.commit('updateField', {
                            key: 'regAccInfo.bank',
                            value: selectedItem.value,
                        })
                    }
                    this.$store.commit('updateField', {
                        key: 'accountInfo.bankName',
                        value: selectedItem.title,
                    })
                    // console.log("bank code:" , this.$store.state.registration.form.asaanAccInfo.bank)
                    // console.log("bankname:" , this.$store.state.registration.form.accountInfo.bankName)
                }
            }
        },
    }, // End of Component > watch
}
</script>
